// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Product } from "../flow/types";

export default function(
  state: Product = initialState.selectedProduct,
  action: any
) {
    let selectedProduct = { ...state };
  switch (action.type) {
      case ActionTypes.GET_PRODUCT + ActionTypes.FULFILLED:
          return action.payload.data;
      case ActionTypes.GENERATE_STOCK_WITH_PRICE + ActionTypes.FULFILLED:
          const stock = action.payload.data;
          const price = stock.price;

          selectedProduct.originalPrice = price.originalPrice;
          selectedProduct.specialPrice = price.specialPrice;
          selectedProduct.stockItemId = stock.stockItemId;
          selectedProduct.stockItemCode = stock.stockCode;
          selectedProduct.hasSingleStock = true;
          return selectedProduct;
      case ActionTypes.RESET_SELECTED_STOCK + ActionTypes.FULFILLED:
          const priceInfo = action.payload;

          selectedProduct.originalPrice = priceInfo.originalPrice;
          selectedProduct.specialPrice = priceInfo.specialPrice;
          selectedProduct.stockItemId = null;
          selectedProduct.stockCode = null;
          selectedProduct.hasSingleStock = false;

          return selectedProduct;
      case ActionTypes.LOGIN + ActionTypes.FULFILLED:
      case ActionTypes.LOGOUT + ActionTypes.FULFILLED:
          return initialState.selectedProduct;
    default:
      return state;
  }
}
